module.exports = __webpack_public_path__ + "img/DCT-logo-150x150.7b3592c2.png";